<template>
  <span
    class="_product-detail-data_"
    :data-pid="productId"
    style="display: none"
  >
    <span class="product-name">{{ name }}</span>
    <span class="product-id">{{ productId }}</span>
    <label :for="`quantity-${uid}`">quantity</label>
    <select :id="`quantity-${uid}`" v-model="quantity" class="quantity-select">
      <option
        v-for="(qty, index) in product.quantities"
        :key="`quantity-${uid}-${index}`"
        :data-url="product.productType !== 'bundle' ? qty.url : ''"
      >
        {{ qty.value }}
      </option>
    </select>

    <div
      v-for="(attr, index) in nonSwatchableAttributes"
      :key="`variation-${uid}-${attr.id}-${index}`"
    >
      <label :class="attr.id" :for="`${attr.id}-${uid}-${index}`">{{
        attr.displayName
      }}</label>
      <select
        :id="`${attr.id}-${uid}-${index}`"
        :class="`custom-select form-control select-${attr.id}`"
      >
        <!-- ${ product.productType === "variant" && isBundle ? "disabled" : "" } -->
        <option :value="attr.resetUrl">{{ attr.displayName }}</option>
        <option
          v-for="(attrValue, valIndex) in attr.values"
          :key="`${attr.id}-${uid}-${valIndex}`"
          :value="attrValue.url"
          :data-attr-value="attrValue.value"
          :disabled="!attrValue.selectable"
          :selected="attrValue.selected || attr.values === 1"
        >
          {{ attrValue.displayValue }}
        </option>
      </select>
    </div>
  </span>
</template>

<script>
import nanoid from 'nanoid/non-secure';
import productPropBaseMixin from '../mixins/productPropBaseMixin';
import productPropSizesMixin from '../mixins/productPropSizesMixin';

export default {
  name: 'BaseProductDataForSfra',

  mixins: [productPropBaseMixin, productPropSizesMixin],

  data() {
    return {
      uid: nanoid(),
      quantity: '1',
      variations: {
        size: '',
      },
    };
  },

  computed: {
    nonSwatchableAttributes() {
      return this.product?.variationAttributes?.filter(
        (attr) => attr !== null && !attr.swatchable
      );
    },
  },
};
</script>
